import React from 'react';
import { Icon } from 'shared-vectors/';
import Check from 'shared-vectors/icons/Check';
import createStyle from 'shared-utils/src/createStyle';

import styles, { mainCls } from './style';
import makeClassName from 'shared-utils/src/makeClassName';

const useStyles = createStyle(styles);

const SelectList = ({
  valuesItems,
  ariaLabelPrefix,
  sortChange,
  sortValue,
  isOpen,
  customCls = null,
}) => {
  const cls = useStyles();
  const baseCssClass = makeClassName([
    cls[mainCls],
    isOpen && cls[`${mainCls}--open`],
    'p--s',
    customCls,
  ]);

  const itemSelectedCls = makeClassName([
    cls[`${mainCls}--item-btn-selected`],
    'tp-w--m tp-s--m',
  ]);

  return (
    isOpen && (
      <ul className={baseCssClass}>
        {Object.keys(valuesItems).map((item) => (
          <li key={item} className={`${mainCls}--li-item`}>
            <button
              type="button"
              aria-label={`${ariaLabelPrefix} ${valuesItems[item]}`}
              onClick={() => sortChange(item)}
              className={`${mainCls}--item-btn tp-w--m p--s ${
                sortValue === item ? itemSelectedCls : ''
              }`}
            >
              {sortValue === item ? (
                <Icon name={Check} width="12px" height="12px" />
              ) : (
                <div className={`${mainCls}--icon-ghost`} />
              )}
              <span className='ml--s'>{valuesItems[item]}</span>
            </button>
          </li>
        ))}
      </ul>
    )
  );
};

export default SelectList;
